exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#OfferPrice {\n  color: #404950;\n  padding: 6px;\n  text-align: center;\n  margin-top: .5rem;\n  margin-bottom: .8rem; }\n  #OfferPrice .price {\n    font-size: 2.35vw;\n    font-weight: 700;\n    line-height: .8em; }\n    #OfferPrice .price span {\n      font-size: 1.6vw;\n      font-weight: 400; }\n  #OfferPrice .price-description {\n    font-size: 1vw;\n    font-weight: 400; }\n", ""]);

// exports
